export const SITE_THEME_OPTIONS = [
  {
    id: "blue-gray",
    label: "Blue-Gray Operations",
    premium: false,
    description: "Current blue-gray operational surface with crisp white cards and light-blue accents.",
    swatches: ["#E8F0F7", "#A3BED5", "#5F86A8"],
    preview: "linear-gradient(135deg, #E8F0F7, #A3BED5 55%, #5F86A8)",
  },
  {
    id: "original-neutral",
    label: "Original Neutral",
    premium: false,
    description: "The earlier refined neutral-gray surface retained as a selectable site preset.",
    swatches: ["#F8F8F8", "#E8E8E8", "#D9E1DE"],
    preview: "linear-gradient(135deg, #F8F8F8, #E8E8E8 55%, #D9E1DE)",
  },
  {
    id: "light-green",
    label: "Light Green",
    premium: false,
    description: "A calm light-green operations surface with fresh, high-contrast accents.",
    swatches: ["#EDF6EF", "#B8D8C0", "#6F9C7B"],
    preview: "linear-gradient(135deg, #EDF6EF, #B8D8C0 55%, #6F9C7B)",
  },
  {
    id: "corkwood",
    label: "Corkwood",
    premium: false,
    description: "A warm corkwood-inspired surface with soft sand and wood-toned accents.",
    swatches: ["#F4EEE5", "#D8C3A5", "#9B795B"],
    preview: "linear-gradient(135deg, #F4EEE5, #D8C3A5 55%, #9B795B)",
  },
  {
    id: "light-khaki",
    label: "Light Khaki",
    premium: false,
    description: "A light khaki palette with muted field-ready tones and clear highlights.",
    swatches: ["#F3F1DF", "#D8D3A8", "#9C986D"],
    preview: "linear-gradient(135deg, #F3F1DF, #D8D3A8 55%, #9C986D)",
  },
  {
    id: "obsidian-glass",
    label: "Obsidian Glass",
    premium: true,
    description: "A deep black glass surface with soft violet-blue haze and high-contrast cards.",
    swatches: ["#080A12", "#27213D", "#5C6EE7"],
    preview: "radial-gradient(circle at 20% 10%, rgba(98, 93, 190, .72), transparent 48%), linear-gradient(135deg, #080A12 0%, #151526 52%, #090A10 100%)",
  },
  {
    id: "amber-glass",
    label: "Amber Glass",
    premium: true,
    description: "A warm smoked-glass gradient with amber highlights inspired by the reference theme.",
    swatches: ["#160F0A", "#5C3D1E", "#D3A24C"],
    preview: "radial-gradient(circle at 18% 18%, rgba(201, 145, 66, .62), transparent 48%), linear-gradient(135deg, #160F0A 0%, #332316 52%, #17120E 100%)",
  },
  {
    id: "ocean-glass",
    label: "Ocean Glass",
    premium: true,
    description: "A cool blue-teal glass surface with mint light blooms and calm dashboard contrast.",
    swatches: ["#081522", "#16465B", "#6BC8A4"],
    preview: "radial-gradient(circle at 22% 16%, rgba(76, 190, 169, .56), transparent 48%), linear-gradient(135deg, #081522 0%, #123A4B 52%, #0A1727 100%)",
  },
  {
    id: "dark-mode",
    label: "Dark Mode",
    premium: false,
    description: "The classic dark interface with high-contrast white text and a neutral graphite surface.",
    swatches: ["#090A0F", "#20242D", "#8FA8C8"],
    preview: "linear-gradient(135deg, #090A0F 0%, #20242D 55%, #0F1720 100%)",
  },
] as const;

export type SiteThemeId = (typeof SITE_THEME_OPTIONS)[number]["id"];
export type SiteThemeOption = (typeof SITE_THEME_OPTIONS)[number];

export const DEFAULT_SITE_THEME: SiteThemeId = "original-neutral";

export function isSiteThemeId(value: unknown): value is SiteThemeId {
  return typeof value === "string" && SITE_THEME_OPTIONS.some((theme) => theme.id === value);
}

export function isPremiumSiteTheme(value: unknown): value is SiteThemeId {
  return SITE_THEME_OPTIONS.some((theme) => theme.id === value && theme.premium === true);
}
